import { createStore } from "vuex";
import {baseService} from "/src/store/base-module";

const store = createStore({
  modules: {
    baseService,
  },
});

export default store;